import { render, staticRenderFns } from "./OrgFeesInPeriodByAttorney.vue?vue&type=template&id=009a3f8d&scoped=true&"
import script from "./OrgFeesInPeriodByAttorney.vue?vue&type=script&lang=js&"
export * from "./OrgFeesInPeriodByAttorney.vue?vue&type=script&lang=js&"
import style0 from "./OrgFeesInPeriodByAttorney.vue?vue&type=style&index=0&id=009a3f8d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009a3f8d",
  null
  
)

export default component.exports